import { useLanguage } from "../../../hooks/hooks";
import { Language } from "../../../types/language";
import { FooterSelector } from "./FooterSelector";

export function LanguageFooterSelector() {
  const { changeLanguage, language, languageOptions } = useLanguage();

  return (
    <FooterSelector
      options={languageOptions}
      selectedValue={language}
      setSelectorOption={(lang) => changeLanguage(lang.value as Language)}
    />
  );
}
